import { ChangeEvent, useState } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import "./SelfSubmit.css";
import { StyledEngineProvider } from '@mui/material/styles';
import { Typography, InputAdornment, Select, MenuItem, InputLabel, SelectChangeEvent } from '@mui/material';
import { DEFAULT_EMPTY_PRESENTER } from '../../../API';
import { MIN_PRESENTER_TIME } from '../../../TimeHelper'


interface SelfSubmitProps {
  /** Callback function when item is submitted */
  writeMeetingChange: (valuesToUpdate: StateUpdateObject) => void;
  /**cookies */
  cookies: any;
  setCookie: Function;
  meetingLength: number;
  setAddPresenterPopup: Function;
  meetingEditsEnabled: boolean;
}


export const SelfSubmit = (props: SelfSubmitProps) => {
  const { writeMeetingChange, cookies, setCookie, setAddPresenterPopup, meetingLength, meetingEditsEnabled } = props;
  const [name, setName] = useState("")
  const [desc, setDesc] = useState("")
  const [lowestTime, setLowestTime] = useState("1")
  const [slotPriority, setSlotPriority] = useState("Standard")
  const [slotType, setSlotType] = useState("Presenter")

  const [tempTime, setTempTime] = useState(Math.round(MIN_PRESENTER_TIME/60).toString());

  const handleSubmit = () => {
    let presenter = {
      ...DEFAULT_EMPTY_PRESENTER,
      id: "PARTICIPANT#" + Math.floor(Math.random() * 1000000000),
      name: name,
      description: (slotType === "Break" ? `${lowestTime}` : desc),
      flight: 3,
      initialDuration: slotType === "Header" ? 0 : parseInt(tempTime) * 60,
      currentDuration: slotType === "Header" ? 0 : parseInt(tempTime) * 60,
      elapsedTime: 0,
      dbElapsedTime: 0,
      startTime: "",
      endTime: "",
      priority: (slotType === "Break" ? -1 : priorityConversion(slotPriority)),
      slotType: slotType

    }

    writeMeetingChange({ presenterAdd: [presenter] })
    setCookie("user", cookies.user + ` ${presenter.id}`, { path: "/" })
    close();
  }

  const close = () => {
    setAddPresenterPopup(false)
    setName("");
    setDesc("");
    setTempTime(MIN_PRESENTER_TIME.toString());
  }

  const handleNameUpdate = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
    setName(event.target.value);
  }

  const handleDescUpdate = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
    setDesc(event.target.value);
  }
  const handleLowestTime = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
    const value = event.target.value;
    if ((/^\d+$/.test(value) && parseInt(value) < 720) || value === "") {
      setLowestTime(value);
    }
  }

  const handlePriorityUpdate = (event: SelectChangeEvent<string>): void => {
    setSlotPriority(event.target.value)
  }
  const handleTypeUpdate = (event: SelectChangeEvent): void => {
    setSlotType(event.target.value)
  }
  const priorityConversion = (priority: string) => {
    if (priority === "High") {
      return 2
    } else if (priority === "Standard") {
      return 1
    } else {
      return 0
    }
  }

  const setMeetingDurationWithInputValidation = ( duration: string ) => {
    if ((/^\d+$/.test(duration) && parseInt(duration) < 720) || duration === "") setTempTime(duration.toString());
  }
  const setMeetingDurationOnBlur = () => {
    let minTime = Math.round(MIN_PRESENTER_TIME/60);
    let maxTime = Math.round(meetingLength/60);
    if (tempTime === "") setTempTime(minTime.toString());

    let tempTimeNumber = parseInt(tempTime);
    if (tempTimeNumber > maxTime) setTempTime(maxTime.toString());
    if (tempTimeNumber < minTime ) setTempTime(minTime.toString());
  }

  return (
    <div id="selfSubmit">
      <StyledEngineProvider injectFirst>
          <Typography align="center" variant="h5" id="addPresenterTitle">
            Add <Select value={slotType} onChange={handleTypeUpdate}>
              <MenuItem value={"Presenter"}><Typography align="center" variant="h5" id="addPresenterTitle">Presenter</Typography></MenuItem>
              <MenuItem value={"Break"}><Typography align="center" variant="h5" id="addPresenterTitle">Break</Typography></MenuItem>
              <MenuItem value={"Header"}><Typography align="center" variant="h5" id="addPresenterTitle">Header</Typography></MenuItem>
            </Select>
          </Typography>
          <div id="fields">
            <div id="nameInput">
              <TextField size="small" fullWidth label={name === "" ? "Name" : " "} value={name} variant="standard" name="name" onChange={handleNameUpdate}
                InputLabelProps={{ style: { fontSize: 18, color: "black" } }} InputProps={{ style: { fontSize: 20 } }} />
            </div>
            {(slotType === "Presenter") &&
              <div id="descInput">
                <TextField multiline size="small" fullWidth label={desc === "" ? "Description" : " "} value={desc} variant="standard" name="desc" onChange={handleDescUpdate}
                  InputLabelProps={{ style: { fontSize: 18, color: "black" } }} InputProps={{ style: { fontSize: 20 } }} />
              </div>
            }
            {(slotType === "Break" || slotType === "Presenter") &&
              <div id="timeInput">
                <TextField size="small" fullWidth inputMode="numeric" label={"Time"} value={tempTime} variant="standard" name="time"
                onChange={(event) => setMeetingDurationWithInputValidation(event.target.value)}
                onBlur={setMeetingDurationOnBlur}
                  InputLabelProps={{ style: { fontSize: 18, color: "black" } }} InputProps={{ style: { fontSize: 20 }, endAdornment: <InputAdornment position='end'>min</InputAdornment> }} />
              </div>
            }
            {(slotType === "Presenter") &&
              <div id="priorityInput">
                <InputLabel style={{ fontSize: 14, color: "black" }}>Priority</InputLabel>
                <Select variant="standard" labelId="Priority" value={slotPriority} name="slotPriority" size="small" onChange={handlePriorityUpdate} inputProps={{ style: { fontSize: 20 } }}>
                  <MenuItem value={"High"}>High</MenuItem>
                  <MenuItem value={"Standard"}>Standard</MenuItem>
                  <MenuItem value={"Low"}>Low</MenuItem>
                </Select>
              </div>
            }
            {(slotType === "Break") &&
              <div id="lowestTimeInput">
                <TextField size="small" fullWidth inputMode="numeric" label={"Minimum Time"} value={lowestTime} variant="standard" onChange={handleLowestTime}
                  InputLabelProps={{ style: { fontSize: 16, color: "black" } }} InputProps={{ style: { fontSize: 20 }, endAdornment: <InputAdornment position='end'>min</InputAdornment> }} />
              </div>
            }
          </div>
          <div id="addPresenterButtons">
            <Button id="submit_button" size="medium" variant="outlined" onClick={() => { setAddPresenterPopup(false) }}>
              Cancel
            </Button>
            <Button id="submit_button" size="medium" variant="outlined" disabled={!meetingEditsEnabled} onClick={() => { handleSubmit() }}>
              Submit
            </Button>
          </div>
      </StyledEngineProvider>
    </div>
  );
}
export default SelfSubmit;